import React from 'react'

const NotFound = () => (
  <div>
    <p>NotFound Component</p>
  </div>
)

export default NotFound
